import BaseModel from './BaseModel';
import { v4 as uuidv4 } from 'uuid';

/** Project-scoped colored label for cards (not billing tags). */
class ProjectLabel extends BaseModel {
    static DEFAULT_COLORS = [
        '#EF4444',
        '#F97316',
        '#EAB308',
        '#22C55E',
        '#14B8A6',
        '#3B82F6',
        '#8B5CF6',
        '#EC4899',
        '#6B7280',
        '#0F172A',
    ];

    _id: string;
    name: string;
    color: string;

    constructor(properties: AnyObj = {}) {
        super({});

        this._id   = properties._id || uuidv4();
        this.name  = properties.name || '';
        this.color = properties.color || ProjectLabel.DEFAULT_COLORS[0];
    }

    /** Readable text color for a hex background. */
    static textColor(hex: string): string {
        const raw = (hex || '').replace('#', '');
        if (raw.length !== 6)
            return '#FFFFFF';
        const r = parseInt(raw.slice(0, 2), 16);
        const g = parseInt(raw.slice(2, 4), 16);
        const b = parseInt(raw.slice(4, 6), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.6 ? '#111827' : '#FFFFFF';
    }
}

export default ProjectLabel;
